import { OrganizationInterface } from "../interfaces/Organizations.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_ORGANIZATION: OrganizationInterface = {
	id: "",
	address: "",
	type: "ORG",
	city: "",
	country: "",
	name: "",
	phone_code: "+1",
	phone: "",
	state: "",
	parent_id: "",
};
